/**
 * Window.ts
 *
 * Module wrapping around the global window object.
 * When the pure npm publish is called, this file will become Window.ts and replace the existing one.
 */
const globalWindow = window;
/**
 * Get the IOfficeBrowserFeedback object
 */
export function get() {
  return w;
}
/**
 * Get the IWindow object
 */
export function getGlobal() {
  return globalWindow;
}
/**
 * Set the setUiStrings() method
 * @param setUiStrings the method
 */
export function setSetUiStrings(setUiStrings) {
  officeBrowserFeedback.setUiStrings = setUiStrings;
  globalWindow.OfficeBrowserFeedback = globalWindow.OfficeBrowserFeedback || {};
  globalWindow.OfficeBrowserFeedback.setUiStrings = officeBrowserFeedback.setUiStrings;
}
/**
 * Set the singleFeedback() method
 * @param singleFeedback the method
 */
export function setSingleFeedback(singleFeedback) {
  officeBrowserFeedback.singleFeedback = singleFeedback;
}
/**
 * Set the multiFeedback() method
 * @param multiFeedback the method
 */
export function setMultiFeedback(multiFeedback) {
  officeBrowserFeedback.multiFeedback = multiFeedback;
}
/**
 * Set the createScreenshot() method
 * @param createScreenshot the method
 */
export function setCreateScreenshot(createScreenshot) {
  officeBrowserFeedback.createScreenshot = createScreenshot;
}
/**
 * Set the isFeedbackSurveyEnabledByAADC() method
 * @param isFeedbackSurveyEnabledByAADC the method
 */
export function setIsFeedbackSurveyEnabledByAADC(isFeedbackSurveyEnabledByAADC) {
  officeBrowserFeedback.isFeedbackSurveyEnabledByAADC = isFeedbackSurveyEnabledByAADC;
}
/**
 * Set the floodgate showSurvey() method
 * @param floodgateShowSurvey the method
 */
export function setFloodgateShowSurvey(floodgateShowSurvey) {
  floodgate.showSurvey = floodgateShowSurvey;
}
/**
 * Set the floodgate showCustomSurvey() method
 * @param floodgateShowSurvey the method
 */
export function setFloodgateShowCustomSurvey(floodgateShowCustomSurvey) {
  floodgate.showCustomSurvey = floodgateShowCustomSurvey;
}
/**
 * Set the floodgate initialize() method
 * @param floodgateInitialize the method
 */
export function setFloodgateInitialize(floodgateInitialize) {
  floodgate.initialize = floodgateInitialize;
}
/**
 * Set the floodgate start() method
 * @param floodgateStart the method
 */
export function setFloodgateStart(floodgateStart) {
  floodgate.start = floodgateStart;
}
/**
 * Set the floodgate stop() method
 * @param floodgateStop the method
 */
export function setFloodgateStop(floodgateStop) {
  floodgate.stop = floodgateStop;
}
/**
 * Set the floodgate getEngine() method
 * @param floodgateGetEngine the method
 */
export function setFloodgateGetEngine(floodgateGetEngine) {
  floodgate.getEngine = floodgateGetEngine;
}
/**
 * Set the floodgate getSettingIdMap() method
 * @param floodgateSettingIdMap the method
 */
export function getSettingIdMap(floodgateSettingIdMap) {
  floodgate.getSettingIdMap = floodgateSettingIdMap;
}
export class Floodgate {}
export class OfficeBrowserFeedback {
  constructor() {
    this.floodgate = new Floodgate();
  }
}
;
export class IOfficeBrowserFeedbackEnv {}
const officeBrowserFeedback = new OfficeBrowserFeedback();
const floodgate = officeBrowserFeedback.floodgate;
const w = {
  OfficeBrowserFeedback: officeBrowserFeedback
};